import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useProductRefreshSettingsIa } from 'features/app_shell/product_refresh/useProductRefreshSettingsIa'
import { isSettingsModalNavigationActive } from 'features/settings_modal/constants'

/**
 * Closes the meetings filter menu when the settings modal overlay opens.
 *
 * Settings uses {@link CenteredOverlay} at `zIndexLowestModal` (15) so the right rail stays
 * interactive; filter menus sit at `zIndexPopover` (400) and would otherwise remain visible on top.
 */
export const useCloseMeetingsFilterMenuOnSettingsModal = (isOpen, onClose) => {
  const location = useLocation()
  const isRebrandSettingsIaEnabled = useProductRefreshSettingsIa()

  const isSettingsModalOpen = isSettingsModalNavigationActive({
    isRebrandSettingsIaEnabled,
    search: location.search,
  })

  useEffect(() => {
    if (!isOpen || !isSettingsModalOpen) {
      return
    }

    onClose?.()
  }, [isOpen, isSettingsModalOpen, onClose])
}
